import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    height={size}
    width={size}
    fill="none"
    {...props}
  >
    <g stroke={color} strokeWidth="2">
      <path d="M8 8V6a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2" strokeLinejoin="round" />
      <path d="M4 9v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9" />
      <path clipRule="evenodd" d="M4 8v11h16V8z" strokeLinejoin="round" />
    </g>
  </svg>
);
